export const routeTranslations = {
    about: {
        header: 'Este es un encabezado de prueba'
    },
    admin: {
        dashboard: {
            label: 'Panel de control',
            title: 'Panel de control de administrador'
        },
        clients: {
            label: 'Clientes'
        },
        contacts: {
            label: 'Contactos'
        },
        export: {
            label: 'Exportar'
        },
        loans: {
            label: 'Préstamos'
        },
        loanGroups: {
            label: 'Grupos de préstamos'
        },
        reports: {
            label: 'Reportes'
        },
        settings: {
            label: 'Ajustes'
        },
        surveys: {
            label: 'Encuestas'
        },
        users: {
            label: 'Usuarios'
        }
    },
    client: {
        contacts: {
            label: 'Contactos',
            title: 'Contactos'
        },
        dashboard: {
            label: 'Panel de control',
            title: 'Panel de control del cliente'
        },
        exports: {
            label: 'Exportaciones'
        },
        financials: {
            label: 'Finanzas'
        },
        goals: {
            label: 'Objetivos'
        },
        profile: {
            label: 'Perfil'
        },
        reports: {
            label: 'Reportes',
            children: {
                reportsAssetLiabilities: {
                    label: 'Activos y pasivos'
                },
                reportsPnl: {
                    label: 'Ganancias y pérdidas'
                }
            }
        },
        settings: {
            label: 'Ajustes'
        },
        surveys: {
            label: 'Encuestas',
            title: 'Encuestas'
        }
    },
    shared: {
        settings: {
            label: 'Ajustes',
            title: 'Ajustes de la cuenta'
        }
    }
};
